<template>
    <div class="layout">
        <el-menu background-color="#2d3a4b" text-color="#fff" active-text-color="#409eff" :default-active="activeIndex"
            class="el-menu-demo" mode="horizontal" :router="true">
            <!-- <el-menu-item index="/home">首页</el-menu-item> -->
            <el-menu-item v-for="route in permissionRoutes" :key="route.name" :index="route.path">{{
                route.meta.title}}</el-menu-item>

            <!-- <el-menu-item index="/innerReport">内部检测报告</el-menu-item>
            <el-menu-item index="/publicReport">公共检测报告库</el-menu-item>
            <el-menu-item index="/user">用户管理</el-menu-item> -->
            <div class="user-info">
                <div class="user-name">
                    <div class="name">
                        {{ this.$store.state.user.email}}
                    </div>
                    <div class="date" v-if="this.$store.state.user.roles==='OUTER'">账号到期时间：{{ this.$store.state.user.expiryDate }}</div>
                </div>
                <div class="logout" @click="handleLogout">退出登陆</div>
            </div>
        </el-menu>
        <router-view style="padding: 10px;"></router-view>
        <Footer></Footer>
    </div>
</template>

<script>
import { asyncRoutes } from '@/router'
import Footer from '@/components/Footer.vue';
export default {
    name: "Layout",
    data() {
        return {
            // activeIndex: '/home',
        };
    },
    components:{
        Footer
    },
    computed: {
        activeIndex() {
            const route = this.$route
            const { meta, path } = route
            // if set path, the sidebar will highlight the path you set
            // if (meta.activeMenu) {
            //     return meta.activeMenu
            // }
            return path
        },
        permissionRoutes() {
            return this.$store.state.user.addRoutes
        }
    },
    methods: {
        handleLogout() {
            this.$store.dispatch('user/logout').then(res => {
                // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
                this.$router.push(`/login`)
            })
        }
    }
}
</script>

<style scoped>
.user-info {
    float: right;
    margin-right: 20px;
    display: flex;
    align-items: center;
    height: 60px;

    .user-name {
        margin-right: 10px;
        color: white;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .date{
            color:#F56C6C
        }
    }

    .logout {
        cursor: pointer;
        color: #409eff;
        line-height: 60px;
    }
}
</style>